
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"26","viewBox":"0 0 40 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 9C0 4.02944 4.02944 0 9 0H31C35.9706 0 40 4.02944 40 9V17C40 21.9706 35.9706 26 31 26H9C4.02944 26 0 21.9706 0 17V9Z","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M8.156 17L10.796 12.68L8.252 8.48H10.016L11.192 10.568L11.72 11.6H11.744C11.904 11.248 12.08 10.904 12.272 10.568L13.46 8.48H15.224L12.668 12.68L15.32 17H13.592L12.26 14.708L11.732 13.7H11.708C11.548 14.044 11.376 14.38 11.192 14.708L9.872 17H8.156ZM16.4968 17V8.48H18.0448V13.4L17.9608 14.72H17.9848C18.2568 14.168 18.4968 13.724 18.7048 13.388L21.9208 8.48H23.4568V17H21.9208V12.092L22.0048 10.772H21.9808C21.7168 11.316 21.4808 11.756 21.2728 12.092L18.0328 17H16.4968ZM27.464 17V9.812H24.668V8.48H31.796V9.812H29V17H27.464Z","fill":"white"}})])
          )
        }
      }
    